import React from 'react';
import { FullTable } from 'components';
import { sortListByKey } from 'utils';
import { scoresBody, scoresHead, scorNotYet } from './constants';
import { useSelector } from 'react-redux';

export const Score = ({}) => {
    const assessmentDetails = useSelector((state) => state.assessment.assessmentById);

    return (
        <div>
            <FullTable
                height={'medium'}
                head={scoresHead}
                body={scoresBody}
                list={sortListByKey(assessmentDetails?.scores, 'name')}
                notYet={scorNotYet}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
